export const baseLayout = (state) => state.baseLayout;
